<template>
  <div
    id="app"
    v-bind:style="
      `background: linear-gradient(0deg, ${config.lowerBackgroundColor} 85%, ${config.upperBackgroundColor} 15%)`
    "
  >
    <div
      class="inner"
      :style="{ backgroundColor: config.innerBackgroundColor }"
    >
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { router } from "./router";
import { mapState } from "vuex";
import { changeFavicon } from "./utils/image";

export default {
  name: "App",
  router,
  computed: {
    ...mapState("settings", ["config"])
  },
  watch: {
    config: {
      handler: function(value) {
        changeFavicon(value.favicon);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

#app {
  font-family: "Roboto", sans-serif;
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  .inner {
    width: 100vw;
    height: 100%;
  }

  @media (min-width: 800px) {
    .inner {
      box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.36);
      margin: 0 auto;
      width: 800px;
      height: 95%;
    }
  }
}
</style>
